/* eslint-disable  @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment */
import React, { useEffect, useContext } from 'react';
import { Form, Select, Tabs, Typography, Input, Card, Row, Col } from 'antd';
import { IUserDetails } from 'src/interfaces';

const FormItem = Form.Item;

type SettingsCardProps = {
    isAdmin: boolean;
    manageUser?: boolean;
    customTitle?: React.ReactElement;
    userDetails: IUserDetails;
    userDetailsLoading?: boolean;
};

function ContactInformationCard({
    isAdmin,
    manageUser,
    customTitle,
    userDetails,
    userDetailsLoading,
}: SettingsCardProps): React.ReactElement {
    const [form] = Form.useForm();
    useEffect(() => {
        form.setFieldsValue(userDetails);
    }, [userDetails]);

    return (
        <>
            <Row
                className="space-between min-width-mobile-320"
                style={{
                    padding: '7px',
                    marginLeft: '5px',
                    marginRight: '5px',
                    background: '#ffffff',
                    borderRadius: '15px',
                }}
            >
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    style={{ marginBottom: '10px' }}
                >
                    <Card className="card" loading={userDetailsLoading}>
                        <Form className="padding-top-lg" form={form}>
                            <Row>
                                <Col
                                    xs={{ span: 24 }}
                                    sm={{ span: 24 }}
                                    md={{ span: 12 }}
                                    lg={{ span: 12 }}
                                    className="padding-right-sm"
                                >
                                    <FormItem name="firstName">
                                        <Input
                                            placeholder="First Name"
                                            style={{ borderWidth: '1px', borderColor: '#EE773B', borderRadius: '50px' }}
                                            readOnly
                                        />
                                    </FormItem>
                                </Col>
                                <Col
                                    xs={{ span: 24 }}
                                    sm={{ span: 24 }}
                                    md={{ span: 12 }}
                                    lg={{ span: 12 }}
                                    className="padding-left-sm"
                                >
                                    <FormItem name="lastName">
                                        <Input
                                            placeholder="Last Name"
                                            style={{ borderWidth: '1px', borderColor: '#EE773B', borderRadius: '50px' }}
                                            readOnly
                                        />
                                    </FormItem>
                                </Col>
                            </Row>
                            <FormItem
                                name="email"
                                rules={[
                                    { required: true, message: 'Email is required' },
                                    { type: 'email', message: 'The input is not valid E-mail!' },
                                ]}
                            >
                                <Input
                                    placeholder="Email"
                                    type="email"
                                    style={{ borderWidth: '1px', borderColor: '#EE773B', borderRadius: '50px' }}
                                    readOnly
                                />
                            </FormItem>
                            <Row>
                                <Col
                                    xs={{ span: 24 }}
                                    sm={{ span: 24 }}
                                    md={{ span: 12 }}
                                    lg={{ span: 12 }}
                                    className="padding-right-sm"
                                >
                                    <FormItem name="phone">
                                        <Input
                                            placeholder="Phone Number"
                                            style={{ borderWidth: '1px', borderColor: '#EE773B', borderRadius: '50px' }}
                                            readOnly
                                        />
                                    </FormItem>
                                </Col>
                                <Col
                                    xs={{ span: 24 }}
                                    sm={{ span: 24 }}
                                    md={{ span: 12 }}
                                    lg={{ span: 12 }}
                                    className="padding-left-sm"
                                >
                                    <FormItem name="fax">
                                        <Input
                                            placeholder="Fax Number"
                                            style={{ borderWidth: '1px', borderColor: '#EE773B', borderRadius: '50px' }}
                                            readOnly
                                        />
                                    </FormItem>
                                </Col>
                            </Row>
                            {(!isAdmin || manageUser) && (
                                <>
                                    <FormItem name="address">
                                        <Input
                                            placeholder="Office Address"
                                            style={{ borderWidth: '1px', borderColor: '#EE773B', borderRadius: '50px' }}
                                            readOnly
                                        />
                                    </FormItem>
                                    <Row>
                                        <Col
                                            xs={{ span: 24 }}
                                            sm={{ span: 24 }}
                                            md={{ span: 8 }}
                                            lg={{ span: 8 }}
                                            className="padding-right-sm"
                                        >
                                            <FormItem name="city">
                                                <Input
                                                    placeholder="City"
                                                    style={{
                                                        borderWidth: '1px',
                                                        borderColor: '#EE773B',
                                                        borderRadius: '50px',
                                                    }}
                                                    readOnly
                                                />
                                            </FormItem>
                                        </Col>
                                        <Col
                                            xs={{ span: 24 }}
                                            sm={{ span: 24 }}
                                            md={{ span: 8 }}
                                            lg={{ span: 8 }}
                                            className="padding-x-sm"
                                        >
                                            <FormItem name="state">
                                                <Select
                                                    placeholder="State"
                                                    style={{
                                                        borderWidth: '1px',
                                                        borderColor: '#EE773B',
                                                        borderRadius: '50px',
                                                    }}
                                                    disabled
                                                />
                                            </FormItem>
                                        </Col>
                                        <Col
                                            xs={{ span: 24 }}
                                            sm={{ span: 24 }}
                                            md={{ span: 8 }}
                                            lg={{ span: 8 }}
                                            className="padding-left-sm"
                                        >
                                            <FormItem name="zip">
                                                <Input
                                                    placeholder="Zip Code"
                                                    style={{
                                                        borderWidth: '1px',
                                                        borderColor: '#EE773B',
                                                        borderRadius: '50px',
                                                    }}
                                                    readOnly
                                                />
                                            </FormItem>
                                        </Col>
                                    </Row>
                                </>
                            )}
                        </Form>
                    </Card>
                </Col>
            </Row>
        </>
    );
}

export default ContactInformationCard;
